import styled from 'styled-components/macro'
import desktopSignupBackground from '../../assets/images/desktop_signup_bg.jpg'
import { device } from '../../constants/media-query'
import { AuthProps } from './login/Login'
import { FormTypes } from 'types/enums/EFormTypes'
import { getBackgroundForForm } from 'constants/form-types-background'

export const AuthContainer = styled.div<AuthProps>`
  height: 100vh;
  width: 100%;
  background: ${({ formType }) =>
    formType === FormTypes.PERSONAL_AREA_PAGE
      ? `url(${getBackgroundForForm(FormTypes.PERSONAL_AREA_PAGE)})`
      : 'none'};
  background-repeat: no-repeat;
  background-size: cover;
  background-position-y: -196px;
  background-position-x: -139px;
  @media ${device.desktop} {
    display: flex;
    ${({ direction }) => direction === 'rtl' && 'flex-direction: row-reverse;'};
    padding: 0;
    width: 100vw;
    /* Background image transition */
    transition: background-image 1.2s ease-in-out;
    background: ${({ formType }) =>
      `url(${getBackgroundForForm(formType as FormTypes)})`};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 0;
    height: 100vh;

    /* Preload second background */
    &:before {
      content: '';
      position: fixed;
      top: -9999px;
      left: -9999px;
      width: 1px;
      height: 1px;
      background-image: url(${desktopSignupBackground});
    }
  }
`

export const AuthFormContainer = styled.div<Partial<AuthProps>>`
  display: flex;
  flex-direction: column;
  text-align: ${({ direction }) => (direction === 'rtl' ? 'right' : 'left')};
  direction: ${({ direction }) => direction};

  @media ${device.desktop} {
    padding: 0;
    height: 100vh;
    width: max-content;
    min-width: ${({ formType }) =>
      formType === FormTypes.PERSONAL_AREA_PAGE ? 'min(90dvw, 876px)' : '35%'};
    max-width: ${({ formType }) =>
      formType === FormTypes.PERSONAL_AREA_PAGE ? 'min(90dvw, 876px)' : '35%'};
    justify-content: center;
  }
`

export const AuthFormBg = styled.div<{
  isLoading: boolean
  formType: AuthProps['formType']
}>`
  background: rgba(245, 245, 245, 1);
  position: relative;
  opacity: ${(props) => (props.isLoading ? 0.5 : 1)};
  padding: 25px 19px 20px 21px;
  height: calc(100vh - 50px);
  margin: ${({ formType }) =>
    formType === FormTypes.PERSONAL_AREA_PAGE ? '120px 0 0' : 'initial'};

  @media ${device.desktop} {
    padding: 25px 36px 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: ${({ formType }) =>
      formType === FormTypes.PERSONAL_AREA_PAGE ? 'flex-start' : 'center'};
    margin: 12px;
    border-radius: 25px;
    overflow: auto;
    width: 100%;
  }
`

export const AuthFormHeader = styled.div`
  padding: 0 0 35px;
  text-align: center;
`

export const AuthFormTitle = styled.div`
  font-size: 30px;
  line-height: 41px;
  letter-spacing: -0.025em;
  color: #000000;
  margin-bottom: 8px;
`

export const AuthFormSubtitle = styled.div`
  font-size: 18px;
  line-height: 20px;
  letter-spacing: -0.025em;
  color: #757575;
`

export const SubmitErrorWrapper = styled.div`
  width: 100%;
  line-height: 20px;
  letter-spacing: -0.075em;
  text-align: center;
  margin-bottom: 10px;
`
